import config from './_oad_repo/config';

config.STRIPE_PUBLISHABLE_KEY = process.env.MIX_STRIPE_PUBLISHABLE_KEY;
config.APP_DOMAIN = process.env.MIX_APP_DOMAIN;

export default config



